import { render } from "./videoplayer-track.vue?vue&type=template&id=234b784b"
import script from "./videoplayer-track.vue?vue&type=script&lang=js"
export * from "./videoplayer-track.vue?vue&type=script&lang=js"

import "./videoplayer-track.vue?vue&type=style&index=0&id=234b784b&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__